import { createRoot } from 'react-dom/client';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { HelmetProvider } from 'react-helmet-async';

import CustomThemeProvider from 'config/themes/CustomThemeProvider';

import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <CustomThemeProvider>
        <SnackbarProvider
          hideIconVariant
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}>
          <Router>
            <App />
          </Router>
        </SnackbarProvider>
      </CustomThemeProvider>
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
